(function () {
  'use strict';

  // Mobile menu toggle
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (toggle) {
      var nav = document.querySelector('[data-mobile-nav]');
      if (nav) nav.classList.toggle('is-open');
    }
  });

  // Cart drawer open/close
  function openDrawer() {
    var d = document.querySelector('[data-cart-drawer]');
    var o = document.querySelector('[data-cart-overlay]');
    if (d) d.classList.add('is-open');
    if (o) o.classList.add('is-open');
  }
  function closeDrawer() {
    var d = document.querySelector('[data-cart-drawer]');
    var o = document.querySelector('[data-cart-overlay]');
    if (d) d.classList.remove('is-open');
    if (o) o.classList.remove('is-open');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) {
      var drawer = document.querySelector('[data-cart-drawer]');
      if (drawer) { e.preventDefault(); openDrawer(); refreshCart(); }
    }
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-overlay]')) {
      closeDrawer();
    }
  });

  function formatMoney(cents) {
    try {
      return (cents / 100).toLocaleString('pt-PT', { style: 'currency', currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR' });
    } catch (err) {
      return '€' + (cents / 100).toFixed(2);
    }
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'inline-flex' : 'none';
    });
  }

  function renderDrawer(cart) {
    var body = document.querySelector('[data-cart-drawer-body]');
    var foot = document.querySelector('[data-cart-drawer-foot]');
    if (!body) return;
    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<div class="cart-empty"><p>O seu carrinho está vazio</p><a class="btn btn--outline" href="/collections/all">Continuar a comprar</a></div>';
      if (foot) foot.innerHTML = '';
      return;
    }
    var html = '';
    cart.items.forEach(function (item) {
      html += '<div class="cart-line">' +
        (item.image ? '<img src="' + item.image + '" alt="">' : '') +
        '<div class="cart-line__info"><div><strong>' + item.product_title + '</strong></div>' +
        (item.variant_title && item.variant_title !== 'Default Title' ? '<div>' + item.variant_title + '</div>' : '') +
        '<div>' + item.quantity + ' × ' + formatMoney(item.final_price) + '</div>' +
        '<button type="button" class="link" data-cart-remove="' + item.key + '">Remover</button>' +
        '</div></div>';
    });
    body.innerHTML = html;
    if (foot) {
      foot.innerHTML = '<div class="cart-foot__subtotal" style="display:flex;justify-content:space-between;margin-bottom:12px">' +
        '<span>Subtotal</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
        '<a class="btn btn--full" href="/checkout">Finalizar compra</a>';
    }
  }

  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        renderDrawer(cart);
      })
      .catch(function () {});
  }

  // Remove from drawer
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-cart-remove]');
    if (!rm) return;
    var key = rm.getAttribute('data-cart-remove');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); renderDrawer(cart); });
  });

  // AJAX add to cart
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action$="/cart/add"], form[action*="/cart/add"]');
    if (!form || !form.hasAttribute('data-ajax-cart')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = '...'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    }).then(function (r) { return r.json(); })
      .then(function () {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Adicionar'; }
        if (document.querySelector('[data-cart-drawer]')) { openDrawer(); refreshCart(); }
        else { refreshCart(); }
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Adicionar'; }
      });
  });

  // Variant selection on product page
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var data = form.querySelector('[data-variants-json]');
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var selects = form.querySelectorAll('[data-option]');
    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var btn = form.querySelector('[type="submit"]');

    function update() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
      if (match) {
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = formatMoney(match.price);
        if (btn) {
          btn.disabled = !match.available;
          btn.textContent = match.available ? (btn.dataset.add || 'Adicionar ao carrinho') : 'Esgotado';
        }
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  });

  // Init cart count on load
  refreshCart();
})();
